import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { DataService } from '../services/data.service';
import { isProprietorAllowedUrl, PROPRIETOR_DEFAULT_ROUTE } from '../shared/constants/proprietor-access.constants';

/**
 * VDS-3444: contiene al propietario puro en modulos que no declaran `Roles`.
 *
 * Se formula como denylist: cualquier actor que no sea propietario puro pasa sin
 * evaluacion, de modo que `admin`, `admin` macro-padre, `customized`, `committee`
 * y `vigilant` conservan exactamente el acceso que tenian.
 */
@Injectable()
export class ProprietorScope implements CanActivate {
  constructor(
    private dataService: DataService,
    private router: Router,
  ) {}

  canActivate(_route: unknown, state: RouterStateSnapshot): boolean {
    if (!this.dataService.isProprietorOnly()) return true;
    if (isProprietorAllowedUrl(state.url)) return true;

    this.router.navigate([PROPRIETOR_DEFAULT_ROUTE]);
    return false;
  }
}
